export const getFillFlowId = state => state.fillFlows.fillFlow.id;
export const getFillFlowData = state => state.fillFlows.fillFlow;
export const fillFlowIsFetching = state => state.fillFlows.loading;
